import { useFormikContext } from "formik";
import React, { useEffect, useState } from "react";
import Select from "react-select";
import { getArticulationOptionList, getSubjects } from "../../../../services/RegistrationService";
import ProgressFieldsStandardReReg from "./components/ProgressFieldsStandardReReg";
import ProgressEngineering from "./components/ProgressEngineering";
import TextInput from "../../../../components/library/TextInput";

function SubjectCheck(props) {
  const standardizedReRegAcademies = ["IT","business","architecture"]
  const [reWriteData, setReWriteData] = useState();
  const [qualificationData, setQualificationData] = useState();
  const [subjectList, setSubjectList] = useState({});
  const [reRegIntakesProgress, setReRegIntakesProgress] = useState();
  const [articulationDropdown, setArticulationDropdown] = useState([])
  
  useEffect(() => {
    getArticulationOptionList({rereg_id: props?.reRegData?.reregistration_id})
    .then((res) => {
      setArticulationDropdown(res.data?.articulations || [])
    }).catch(err => {
      console.log("subjectCheck.js -> getArticulationOptionList Error ->",err.message)
    })
  },[])

  let dropdownValues = {
    registerFor: [
      {label: "First Year - Bachelor of Arts Degree in Interior Design",value: "1"},
      {label: "First Year - Bachelor of Arts Degree in Graphic Design",value: "2"},
      {label: "First Year - Bachelor of Arts Degree in Multimedia Design",value: "3"},
      {label: "Second Year - BA Graphic Design",value: "4"},
      {label: "Second Year - BA Multimedia Design",value: "5"},
      {label: "Second Year - BA Interior Design",value: "6"},
      {label: "Third year-Graphic Design",value: "7"},
      {label: "Third year-Interior Design",value: "8"},
      {label: "Third year Multimedia Design",value: "9"},
      {label: "BA Honours-Interior Design",value: "10"},
      {label: "BA Honours Multimedia Design",value: "11"},
      {label: "BA Honours-Visual Communication",value: "12"},
      {label: "Higher Certificate in Game Design and Development",value: "21"},
      {label: "Higher Certificate in Creative Music Technology",value: "22"},      
      {label: "Diploma in Music Technology (1st Year)",value: "23"},
      {label: "Diploma in Music Technology (2nd Year)",value: "24"},
      {label: "Diploma in Music Technology (3rd Year)",value: "25"}
    ],
    repeat: [
      {label: "Critical Studies",value: "4"},
      {label: "Design Studio, Visual Communication and Technology and Professional Practice",value: "5"},
      {label: "Minor Module",value: "6"},
      {label: "Major Module",value: "7"},
      {label: "Applied Digital Arts 101",value: "101"},             
      {label: "3D Modelling and Animation 101",value: "102"},             
      {label: "Game Design Practice 101",value: "103"},             
      {label: "Game Development and Scripting 101",value: "104"},             
      {label: "Contemporary Game Theory 101",value: "105"},             
      {label: "Audio for Game Design",value: "106"},             
      {label: "Audio Fundamentals 101",value: "107"},             
      {label: "Modern Music Theory 101",value: "108"},             
      {label: "Music Ear Training 101",value: "109"},             
      {label: "Music Production Technique 101",value: "110"},             
      {label: "Music Software Cubase 101",value: "111"},             
      {label: "Studio Sound Engineering 101",value: "112"},             
      {label: "Signal Processing 102",value: "113"},             
      {label: "Modern Music Theory 102",value: "114"},             
      {label: "Music Ear Training 102",value: "115"},             
      {label: "Music Production Technique 102",value: "116"},             
      {label: "Music Software FL Studio 101",value: "117"},             
      {label: "Recording Projects 102",value: "118"},             
      {label: "Music Production Software 101",value: "119"},             
      {label: "Music Production Software 110",value: "120"},             
      {label: "Music for Game Audio 102",value: "121"},             
      {label: "Music Production Technique 201",value: "122"},             
      {label: "Studio Sound Engineering 201",value: "123"},             
      {label: "Modern Music Theory 201",value: "124"},             
      {label: "Music Business 201",value: "125"},             
      {label: "Music Production Software 201",value: "126"},                       
      {label: "Live Sound Engineering 201",value: "128"},             
      {label: "Music Production Software 210",value: "129"},             
      {label: "Audio Post Production 301",value: "130"},             
      {label: "Music Business 301",value: "131"},             
      {label: "Music Industry Praxis 301",value: "132"},             
      {label: "Audio Mastering Techniques 302",value: "133"},           
      {label: "Audio Ear Training 201",value: "134"},         
      {label: "Recording Project 102",value: "135"},         
      {label: "Music Business Entrepreneurship 301",value: "136"}           
    ],
    progress : [
      {label : "Progress to SSD 2nd Year",value : "Progress to SSD 2nd Year"}
    ],
    elective :[
      {label: "Media Music Composition 301",value: "1001"},             
      {label: "Electronic Music Production 301",value: "1002"},             
      {label: "Sound Synthesis and Design 301",value: "1003"},             
      {label: "Studio Sound Engineering 301",value: "1004"}
    ]
  }
  
  useEffect(() => {
    let rewrite = props.studentData?.re_submission;
    let qualification = props.studentData?.progress_list;
    let modifiedArr = []
    let qualificationArr = []
    rewrite && rewrite.map(elem => {
      modifiedArr.push({ value: elem?.intakeID, label: elem.courseName + " - ( Intake-" + elem.number + "-" + elem.year + "-" + elem.type + ") " });
    })
    qualification && qualification.map(elem => {
      qualificationArr.push({ value: elem.id, label: elem.course + " - ( Intake-" + elem.number + "-" + elem.year + "-" + elem.type + ") " });
    })
    setReWriteData(modifiedArr)
    setQualificationData(qualificationArr)
    formik.setFieldValue("progress_intake_id", props.studentData?.reRegIntakesProgress[0]?.id);
    
    if (props && props.subjectCheckIds && props.subjectCheckIds.totalArr) {
      props.subjectCheckIds.totalArr.map((item, index) => {
        getSubjectsList(item.qualification, ++index)
      })
    }
  }, [props]);
  
  const formik = useFormikContext();
  
  
  const getSubjectsList = (id, num) => {
    if (id) {
      getSubjects(id).then(response => {
        let subjectList = response.data.SubjectsList
        let modifiedArr = []
        subjectList && subjectList.map(elem => {
          modifiedArr.push({ value: elem?.intakeID, label: elem.courseName + " - ( Intake-" + elem.number + "-" + elem.year + "-" + elem.type + ") " });
        })
        setSubjectList(prev => ({ ...prev, [num]: modifiedArr }));
      }).catch(error => {
        console.log("error >>>>> ", error);
      })
    }
  }
  
  const reWriteDiv = [1, 2, 3, 4, 5,6].map((item, index) => {
    return (
      <div className="row align-items-center mb-4" key={index}>
      <div className="col-md-3">
      {/* <label htmlFor={`Rewrite${item}`}>Re-Write</label> */}
      </div>
      <div className="col-md-4">
      <div className="form-icon-group">
      <Select
      className={"form-control custom-select-box "}
      name={`Rewrite${item}`}
      value={reWriteData && reWriteData.filter((data) => {
        return (props.reWriteIds && props.reWriteIds[`reWrite${item}`]) == data.value
      })}
      onChange={(value) => {
        if (value) {
          props.setReWriteIds(oldVal => ({ ...oldVal, [`reWrite${item}`]: value.value }))
          formik.setFieldValue('student_type', 0)
        } else {
          props.setReWriteIds(oldVal => ({ ...oldVal, [`reWrite${item}`]: "" }))
        }
      }}
      isClearable
      onBlur={formik.handleBlur}
      options={reWriteData}
      isDisabled={Boolean(props.disabled)}
      maxMenuHeight={175}
      placeholder={(props.reWriteIds && props.reWriteIds[`reWrite${item}`]) ? (props.reWriteIds[`reWrite${item}`]) : "Select"}
      />
      </div>
      </div>
      </div>
    )
  })
  
  const getRedoFieldCount = () =>{
    if(props.reRegData.academy == 'beauty' || standardizedReRegAcademies.includes(String(props.reRegData.academy)) || props.reRegData.academy == 'artisans'){      
      if(props?.redoIds?.totalArr && props?.redoIds?.totalArr.length && props?.redoIds?.totalArr.length>5){        
        return Object.keys(props.redoIds.totalArr).map(key => parseInt(key)+1)
      }
      return [1, 2, 3, 4, 5,6,7,8]
    }
    
    return [1, 2, 3, 4, 5,6,7,8];
  }
  const redoDiv = getRedoFieldCount().map((item, index) => {
    return (
      <div className="row align-items-center mb-4" key={index}>
      <div className="col-md-3">
      {/* <label htmlFor={`Redo${item}`}>Re-Do</label> */}
      </div>
      <div className="col-md-4">
      <div className="form-icon-group">
      <Select
      className={"form-control custom-select-box "}
      name={`Redo${item}`}
      isDisabled={Boolean(props.disabled)}
      value={ ((formik.values.foundation == 0 || formik.values.foundation == null) && (formik.values.student_type == 0 || formik.values.student_type == null)) ? reWriteData && reWriteData.filter((data) => {
        return ((props.redoIds && String(props.redoIds[`redo${item}`]) != "0") && props.redoIds[`redo${item}`] == data.value) ?? ""
      }) : ""}
      onChange={(value) => {
        if (value) {
          props.setRedoIds(oldVal => ({ ...oldVal, [`redo${item}`]: value.value }))
          formik.setFieldValue('foundation', false);
          formik.setFieldValue('student_type', 0);
        } else {
          props.setRedoIds(oldVal => ({ ...oldVal, [`redo${item}`]: "" }))
        }
      }}
      isClearable
      onBlur={formik.handleBlur}
      options={reWriteData}
      maxMenuHeight={175}
      placeholder={(((formik.values.foundation == 0 || formik.values.foundation == null) && (formik.values.student_type == 0 || formik.values.student_type == null))  && props.redoIds && props.redoIds[`redo${item}`] &&  String(props.redoIds[`redo${item}`]) != '0') ? (props.redoIds[`redo${item}`]) : "Select..."}
      />
      </div>
      </div>
      </div>)
    })
    const progressDiv = 
    <>
    <p className="subjectcheck-title" >Nated Progression</p>
    {[1,2,3,4,5,6].map((itemNo, index) => (
      <React.Fragment key={index}>
      <div className="row align-items-center mb-4">
      <div className="col-md-3">
      <label htmlFor={`Qualification${itemNo}`}>Qualification </label>
      </div>
      <div className="col-md-3">
      <div className="form-icon-group">
      <Select
      className={"form-control custom-select-box "}
      name={`Qualification${itemNo}`}
      isDisabled={Boolean(props.disabled) || formik?.values?.foundation}
      value={(((formik.values.foundation == 0 || formik.values.foundation == null) 
        && (formik.values.student_type == 0 || formik.values.student_type == null))   
        && qualificationData) && qualificationData?.filter((data) => {
         return (String(props.subjectCheckIds?.[`qualification${itemNo}`]) != "0" 
         && (props.subjectCheckIds 
          && props.subjectCheckIds?.[`qualification${itemNo}`]) == data.value)
      })}
      onChange={(value) => {
        // console.log("Value changed: ", value);
        if (value) {
          props.setSubjectCheckIds(oldVal => ({ ...oldVal, [`qualification${itemNo}`]: value.value, [`subject${itemNo}`]: "", [`subjectName${itemNo}`]: "" }))
          // console.log("props.subjectCheckIds", props.subjectCheckIds);
          getSubjectsList(value.value, itemNo)
          formik.setFieldValue('foundation', false);
          formik.setFieldValue('student_type', 0);
        } else {
          // console.log("Nothing selected");
          props.setSubjectCheckIds(oldVal => ({ ...oldVal, [`qualification${itemNo}`]: "", [`subject${itemNo}`]: "", [`subjectName${itemNo}`]: "" }))
          getSubjectsList("", itemNo)
        }
      }}
      isClearable
      onBlur={formik.handleBlur}
      options={qualificationData}
      maxMenuHeight={175}
      placeholder={props.subjectCheckIds && props.subjectCheckIds?.[`qualification${itemNo}`] ? props.subjectCheckIds?.[`qualification${itemNo}`] : "Select"}
      />
      </div>
      </div>
      <div className="col-md-3">
      <label htmlFor={`Subject${itemNo}`}>Subject</label>
      </div>
      <div className="col-md-3">
      <div className="form-icon-group">
      <Select
      className={"form-control custom-select-box " + (formik.errors?.[`subject${itemNo}`] && formik.touched?.[`subject${itemNo}`] ? " is-invalid" : "")}
      name={`subject${itemNo}`}
      isDisabled={Boolean(props.disabled) || formik?.values?.foundation}
      value={(((formik.values.foundation == 0 || formik.values.foundation == null) 
        && (formik.values.student_type == 0 || formik.values.student_type == null)) 
        && subjectList[itemNo]) 
          && subjectList[itemNo].filter(item => 
          String(props.subjectCheckIds?.[`subject${itemNo}`]) != "0" && props.subjectCheckIds && props.subjectCheckIds?.[`subject${itemNo}`] == item.value)
      }
      onChange={(value) => {
        // console.log("Value changed: ", value);
        if (value) {
          props.setSubjectCheckIds(oldVal => ({ ...oldVal, [`subject${itemNo}`]: value.value }))
          // console.log("props.subjectCheckIds", props.subjectCheckIds);
          formik.setFieldValue('student_type', 0)
          formik.setFieldValue('foundation', false);
        } else {
          // console.log("Nothing selected");
          props.setSubjectCheckIds(oldVal => ({ ...oldVal, [`subject${itemNo}`]: "" }))
        }
      }}
      isClearable
      onBlur={formik.handleBlur}
      options={subjectList[itemNo]}
      maxMenuHeight={175}
      placeholder={ ((formik.values.foundation == 0 || formik.values.foundation == null) && (formik.values.student_type == 0 || formik.values.student_type == null)) 
        && props.subjectCheckIds && props.subjectCheckIds?.[`qualification${itemNo}`] 
        && props.subjectCheckIds?.[`qualification${itemNo}`] != "0" && props.subjectCheckIds?.[`subject${itemNo}`] 
        ? props.subjectCheckIds?.[`subject${itemNo}`] 
        : ((formik.values.foundation == 0 || formik.values.foundation == null) && (formik.values.student_type == 0 || formik.values.student_type == null)) 
        && props.subjectCheckIds &&  props.subjectCheckIds?.[`subjectName${itemNo}`] 
        ? props.subjectCheckIds?.[`subjectName${itemNo}`] 
        : "Select"}
        />
        </div>
        </div>
        </div>
        </React.Fragment>
      ))}
      </>
      
      const registerForDiv = [1].map((item, index) => {
        return (
          <div className="row align-items-center mb-4" key={index}>
          <div className="col-md-3">
          <label htmlFor={`registerFor${item}`}>Register For</label>
          </div>
          <div className="col-md-4">
          <div className="form-icon-group">
          <Select
          className={"form-control custom-select-box "}
          name={`registerFor${item}`}
          isDisabled={Boolean(props.disabled)}
          value={dropdownValues.registerFor && dropdownValues.registerFor.filter((data) => {
            return (props.registerFor && props.registerFor[`registerFor${item}`]) == data.value
          })}
          onChange={(value) => {
            if (value) {
              props.setRegisterFor(oldVal => ({ ...oldVal, [`registerFor${item}`]: value.value }))
              formik.setFieldValue('student_type', 0)
              formik.setFieldValue('foundation', false)
            } else {
              props.setRegisterFor(oldVal => ({ ...oldVal, [`registerFor${item}`]: "" }))
            }
          }}
          isClearable
          onBlur={formik.handleBlur}
          options={dropdownValues.registerFor}
          maxMenuHeight={175}
          placeholder={(props.registerFor && props.registerFor[`registerFor${item}`]) ? (props.registerFor[`registerFor${item}`]) : "Select"}
          />
          </div>
          </div>
          </div>)
        })
        
        const getRepeatField = () =>{
          if(props.reRegData.academy == 'gdc' || props.reRegData.academy == 'visual_art' || props.reRegData.academy == 'visual_design'){
            return [1,2,3,4]
          }
          return [1, 2, 3, 4, 5, 6, 7]
        }
        const repeatDiv = getRepeatField().map((item, index) => {
          return (
            <div className="row align-items-center mb-4" key={index}>
            <div className="col-md-3">
            <label htmlFor={`repeat${item}`}>Repeat</label>
            </div>
            <div className="col-md-4">
            <div className="form-icon-group">
            <Select
            className={"form-control custom-select-box "}
            name={`repeat${item}`}
            isDisabled={Boolean(props.disabled)}
            value={dropdownValues.repeat && dropdownValues.repeat.filter((data) => {
              return (props.repeat && props.repeat[`repeat${item}`]) == data.value
            })}
            onChange={(value) => {
              if (value) {
                props.setRepeat(oldVal => ({ ...oldVal, [`repeat${item}`]: value.value }))
              } else {
                props.setRepeat(oldVal => ({ ...oldVal, [`repeat${item}`]: "" }))
              }
            }}
            isClearable
            onBlur={formik.handleBlur}
            options={dropdownValues.repeat}
            maxMenuHeight={175}
            placeholder={(props.repeat && props.repeat[`repeat${item}`]) ? (props.repeat[`repeat${item}`]) : "Select"}
            />
            </div>
            </div>
            </div>)
          })
          
          const electiveDiv = [1, 2].map((item, index) => {
            return (
              <div className="row align-items-center mb-4" key={index}>
              <div className="col-md-3">
              <label htmlFor={`elective${item}`}>Repeat Electives</label>
              </div>
              <div className="col-md-4">
              <div className="form-icon-group">
              <Select
              className={"form-control custom-select-box "}
              name={`elective${item}`}
              value={dropdownValues.elective && dropdownValues.elective.filter((data) => {
                return (props.elective && props.elective[`elective${item}`]) == data.value
              })}
              onChange={(value) => {
                if (value) {
                  props.setElective(oldVal => ({ ...oldVal, [`elective${item}`]: value.value }))
                } else {
                  props.setElective(oldVal => ({ ...oldVal, [`elective${item}`]: "" }))
                }
              }}
              isClearable
              isDisabled={Boolean(props.disabled)}
              onBlur={formik.handleBlur}
              options={dropdownValues.elective}
              maxMenuHeight={175}
              placeholder={(props.elective && props.elective[`elective${item}`]) ? (props.elective[`elective${item}`]) : "Select"}
              />
              </div>
              </div>
              </div>)
            })
            
            const divRenderCondition = () => {
              if (props.reRegData.academy == 'engineering') {
                return (
                  <>
                  <div className='card-header'>Re-register Modules:</div>
                  {redoDiv}
                  {progressDiv}
                  <ProgressEngineering articulationDropdown={articulationDropdown} disabled={Boolean(props.disabled)} formik={formik} progressId={formik.values.progress_q1} setProgressId={setReRegIntakesProgress}/>
                  </>
                )
              } else if (props.reRegData.academy == 'draughting') {
                return <>
                <div className='card-header'>Re-Write Modules:</div>
                {reWriteDiv}
                <div className='card-header'>Re-Do Modules:</div>
                {redoDiv}
                </>
              } else if (props.reRegData.academy == 'draughting' && props.reRegData['qualification'] !== 'draughting_NDSSD') {
                return ""
              } else if (props.reRegData.academy == 'gdc' || props.reRegData.academy == 'visual_art' || props.reRegData.academy == 'visual_design') {
                return <>
                {registerForDiv}
                {repeatDiv}
                </>
              } else if (props.reRegData.academy == 'fst' || props.reRegData.academy == 'fg') {
                return <>
                {registerForDiv}
                {repeatDiv}
                {electiveDiv}
                </>
              }else if(standardizedReRegAcademies.includes(String(props.reRegData.academy))){
                return <>
                {/* {redoDiv} */}
                <div className='card-header'>Re-register Modules:</div>
                {redoDiv}
                <ProgressFieldsStandardReReg articulationDropdown={articulationDropdown} disabled={Boolean(props.disabled)} formik={formik} progressId={formik.values.progress_q1} setProgressId={setReRegIntakesProgress}/>
                </>
              }else if(props.reRegData.academy == 'beauty' || props.reRegData.academy == 'artisans'){
                return <>
                {redoDiv}
                </>
              }
            }
            useEffect(() => {
              if (String(props?.reRegData?.academy) === 'engineering' || standardizedReRegAcademies.includes(String(props.reRegData.academy))) {
                if ((formik.values.student_type === null || Number(formik.values.student_type) == 0)) {
                  formik.setFieldValue('progress_q1', '');
                    setReRegIntakesProgress('');
                } else {
                  props.setRedoIds({ redo1: 0, redoId1: 0, totalArr: [] });
                  props.setReSubmissionIds({reSubmission1: 0, totalArr: []});
                  props.setSubjectCheckIds({ qualification1: 0, subject1: 0, totalArr: [] });
                }
              }
            }, [formik.values.foundation, formik.values.student_type]);
            return (
              <div className="my-tickets-info-list Tickets-main-wrap">
              <div className="edit-icon new-card-header">
              <div className="card-header">Subject Checks</div>
              </div>
              <div className="row align-items-center mb-4">
              <div className="col-md-12 col-lg-7">
              <TextInput
                id="StudentSelection"
                label="Student Selection"
                name="StudentSelection"
                value={formik.values.StudentSelection || ""}
                placeholder="Student Selection"
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                error={!!(formik.errors.StudentSelection && formik.touched.StudentSelection)}
                errorText={formik.errors.StudentSelection && formik.touched.StudentSelection ? formik.errors.StudentSelection : ""}
                multiline
                rows={10}
              />
              </div>
              </div>
              {!props.toShowBachleor && divRenderCondition()}              
                {!props.toShowBachleor &&
                  ((props.reRegData['academy'] == "draughting" && props.reRegData['qualification'] == "draughting_NDSSD") || (props.reRegData['academy'] == "draughting")) ?
                  <div className="row align-items-center mb-4">
                  <div className="col-md-6 col-lg-3">
                  <label htmlFor="progress_q1">Progress </label>
                  </div>
                  <div className="col-md-6 col-lg-4">
                  <div className="form-icon-group">
                  <Select
                  className={"form-control custom-select-box " + (formik.errors.progress_q1 && formik.touched.progress_q1 ? " is-invalid" : "")}
                  name="progress_q1"
                  isDisabled={Boolean(props.disabled)}
                  value={qualificationData?.filter((data) => {
                    return data.value == formik.values.progress_q1
                  })}
                  onChange={async (value) => {
                    if (value) {
                      formik.setFieldValue("progress_q1", value.value);
                      setReRegIntakesProgress(value.label)
                    } else {
                      formik.setFieldValue("progress_q1", "");
                      setReRegIntakesProgress("")
                    }
                  }}
                  isClearable
                  onBlur={formik.handleBlur}
                  options={qualificationData}
                  maxMenuHeight={175}
                  placeholder={reRegIntakesProgress ? reRegIntakesProgress : "Select"}
                  />
                  </div>
                  </div>
                  </div> :""
                }
                </div >
              );
            }
            
            export default SubjectCheck;